import { ApplicationScheme } from '../../../common/types';
import { CorporateQuestionnarieFormValues } from '../../../corporate/types';

const getCorporateQuestionnarieBody = ({
  questionnarieValues,
  scheme,
}: {
  questionnarieValues: CorporateQuestionnarieFormValues;
  scheme: ApplicationScheme;
}) => {
  const questionnarieBody: CorporateQuestionnarieFormValues = {};

  if (
    scheme?.accountantDetailsActive &&
    questionnarieValues.accountantDetails
  ) {
    questionnarieBody.accountantDetails = questionnarieValues.accountantDetails;
  }

  if (scheme?.auditedByExternalComplianceActive) {
    if (questionnarieValues.hasAuditedByExternalCompliance) {
      questionnarieBody.hasAuditedByExternalCompliance = Boolean(
        questionnarieValues.hasAuditedByExternalCompliance === 'yes',
      );
    }

    if (questionnarieValues.auditedByExternalComplianceDetails) {
      questionnarieBody.auditedByExternalComplianceDetails =
        questionnarieValues.auditedByExternalComplianceDetails;
    }
  }

  if (scheme?.changesInManagementOrOwnershipActive) {
    if (questionnarieValues.hasChangesInManagementOrOwnership) {
      questionnarieBody.hasChangesInManagementOrOwnership = Boolean(
        questionnarieValues.hasChangesInManagementOrOwnership === 'yes',
      );
    }

    if (questionnarieValues.changesInManagementOrOwnershipDetails) {
      questionnarieBody.changesInManagementOrOwnershipDetails =
        questionnarieValues.changesInManagementOrOwnershipDetails;
    }
  }

  if (
    scheme?.complianceConsultantDetailsActive &&
    questionnarieValues.complianceConsultantDetails
  ) {
    questionnarieBody.complianceConsultantDetails =
      questionnarieValues.complianceConsultantDetails;
  }

  if (scheme?.fcaNumberActive && questionnarieValues.fcaNumber) {
    questionnarieBody.fcaNumber = questionnarieValues.fcaNumber;
  }

  if (scheme?.hmrcMlrNumberActive && questionnarieValues.hmrcMlrNumber) {
    questionnarieBody.hmrcMlrNumber = questionnarieValues.hmrcMlrNumber;
  }

  if (
    scheme?.hmrcRegistrationExpiryDateActive &&
    questionnarieValues.hmrcRegistrationExpiryDate
  ) {
    questionnarieBody.hmrcRegistrationExpiryDate =
      questionnarieValues.hmrcRegistrationExpiryDate;
  }

  if (scheme?.icoNumberActive && questionnarieValues.icoNumber) {
    questionnarieBody.icoNumber = questionnarieValues.icoNumber;
  }

  if (
    scheme?.itProviderDetailsActive &&
    questionnarieValues.itProviderDetails
  ) {
    questionnarieBody.itProviderDetails = questionnarieValues.itProviderDetails;
  }

  if (scheme?.mlroDetailsActive && questionnarieValues.mlroDetails) {
    questionnarieBody.mlroDetails = questionnarieValues.mlroDetails;
  }

  if (scheme?.numberOfAgentsActive && questionnarieValues.numberOfAgents) {
    questionnarieBody.numberOfAgents = questionnarieValues.numberOfAgents;
  }

  if (scheme?.numberOfBranchesActive && questionnarieValues.numberOfBranches) {
    questionnarieBody.numberOfBranches = questionnarieValues.numberOfBranches;
  }

  if (
    scheme?.onboardCorporateClientsActive &&
    questionnarieValues.hasOnboardCorporateClients
  ) {
    questionnarieBody.hasOnboardCorporateClients = Boolean(
      questionnarieValues.hasOnboardCorporateClients === 'yes',
    );
  }

  if (scheme?.onboardMsbActive && questionnarieValues.hasOnboardMsb) {
    questionnarieBody.hasOnboardMsb = Boolean(
      questionnarieValues.hasOnboardMsb === 'yes',
    );
  }

  if (
    scheme?.paymentsForCharitiesActive &&
    questionnarieValues.hasPaymentsForCharities
  ) {
    questionnarieBody.hasPaymentsForCharities = Boolean(
      questionnarieValues.hasPaymentsForCharities === 'yes',
    );
  }

  if (
    scheme?.payoutPartnerDetailsActive &&
    questionnarieValues.payoutPartnerDetails
  ) {
    questionnarieBody.payoutPartnerDetails =
      questionnarieValues.payoutPartnerDetails;
  }

  if (scheme?.regulatoryInvestigationActive) {
    if (questionnarieValues.hasRegulatoryInvestigation) {
      questionnarieBody.hasRegulatoryInvestigation = Boolean(
        questionnarieValues.hasRegulatoryInvestigation === 'yes',
      );
    }

    if (questionnarieValues.regulatoryInvestigationDetails) {
      questionnarieBody.regulatoryInvestigationDetails =
        questionnarieValues.regulatoryInvestigationDetails;
    }
  }

  if (scheme?.screeningActive) {
    if (questionnarieValues.hasScreening) {
      questionnarieBody.hasScreening = Boolean(
        questionnarieValues.hasScreening === 'yes',
      );
    }

    if (questionnarieValues.screeningKind) {
      questionnarieBody.screeningKind = questionnarieValues.screeningKind;
    }
  }

  if (scheme?.transactionMonitoringActive) {
    if (questionnarieValues.hasTransactionMonitoring) {
      questionnarieBody.hasTransactionMonitoring = Boolean(
        questionnarieValues.hasTransactionMonitoring === 'yes',
      );
    }

    if (questionnarieValues.transactionMonitoringKind) {
      questionnarieBody.transactionMonitoringKind =
        questionnarieValues.transactionMonitoringKind;
    }
  }

  if (
    scheme?.typeOfBusinessLicenceActive &&
    questionnarieValues.typeOfBusinessLicence
  ) {
    questionnarieBody.typeOfBusinessLicence =
      questionnarieValues.typeOfBusinessLicence;
  }

  if (scheme?.visitedByAuthoritiesActive) {
    if (questionnarieValues.visitedByAuthorities) {
      questionnarieBody.visitedByAuthorities =
        questionnarieValues.visitedByAuthorities;
    }

    if (questionnarieValues.visitedByAuthoritiesDetails) {
      questionnarieBody.visitedByAuthoritiesDetails =
        questionnarieValues.visitedByAuthoritiesDetails;
    }
  }

  if (scheme?.workingWithAnyOtherIPSPActive) {
    if (questionnarieValues.hasWorkingWithAnyOtherIpsp) {
      questionnarieBody.hasWorkingWithAnyOtherIpsp = Boolean(
        questionnarieValues.hasWorkingWithAnyOtherIpsp === 'yes',
      );
    }

    if (questionnarieValues.workingWithAnyOtherIpspDetails) {
      questionnarieBody.workingWithAnyOtherIpspDetails =
        questionnarieValues.workingWithAnyOtherIpspDetails;
    }
  }

  if (scheme?.id === 'cdbb8c71-90e6-4a5e-964f-e55169e0c4df') {
    if (questionnarieValues?.tradingName) {
      questionnarieBody.tradingName = questionnarieValues?.tradingName;
    }

    if (questionnarieValues?.contactPersonName) {
      questionnarieBody.contactPersonName =
        questionnarieValues?.contactPersonName;
    }

    if (questionnarieValues?.phoneNumber) {
      questionnarieBody.phoneNumber = questionnarieValues?.phoneNumber;
    }

    if (questionnarieValues?.faxNumber) {
      questionnarieBody.faxNumber = questionnarieValues?.faxNumber;
    }

    if (questionnarieValues?.contactEmail) {
      questionnarieBody.contactEmail = questionnarieValues?.contactEmail;
    }

    if (questionnarieValues?.legalEntityIdCode) {
      questionnarieBody.legalEntityIdCode =
        questionnarieValues?.legalEntityIdCode;
    }

    if (
      questionnarieValues?.isPepOrAssociate?.toString() !== 'null' &&
      questionnarieValues?.isPepOrAssociate?.toString() !== 'undefined'
    ) {
      questionnarieBody.isPepOrAssociate = Boolean(
        questionnarieValues.isPepOrAssociate === 'yes',
      );
    }

    if (questionnarieValues?.nameOfPep) {
      questionnarieBody.nameOfPep = questionnarieValues?.nameOfPep;
    }

    if (questionnarieValues?.relToCustomerId) {
      questionnarieBody.relToCustomerId = questionnarieValues?.relToCustomerId;
    }

    if (questionnarieValues?.relToPep) {
      questionnarieBody.relToPep = questionnarieValues?.relToPep;
    }

    if (questionnarieValues?.orgEmployerAndPosition) {
      questionnarieBody.orgEmployerAndPosition =
        questionnarieValues?.orgEmployerAndPosition;
    }

    if (questionnarieValues?.positionHeldCountryId) {
      questionnarieBody.positionHeldCountryId =
        questionnarieValues?.positionHeldCountryId;
    }

    if (questionnarieValues?.politicalFunctionPeriodFrom) {
      questionnarieBody.politicalFunctionPeriodFrom = new Date(
        questionnarieValues?.politicalFunctionPeriodFrom,
      ).toISOString();
    }

    if (questionnarieValues?.politicalFunctionPeriodTo) {
      questionnarieBody.politicalFunctionPeriodTo = new Date(
        questionnarieValues?.politicalFunctionPeriodTo,
      ).toISOString();
    }

    if (
      questionnarieValues?.abilityMoveGovernmentFunds?.toString() !== 'null' &&
      questionnarieValues?.abilityMoveGovernmentFunds?.toString() !==
        'undefined'
    ) {
      questionnarieBody.abilityMoveGovernmentFunds = Boolean(
        questionnarieValues.abilityMoveGovernmentFunds === 'yes',
      );
    }

    if (questionnarieValues?.abilityMoveGovernmentFundsDetails) {
      questionnarieBody.abilityMoveGovernmentFundsDetails =
        questionnarieValues?.abilityMoveGovernmentFundsDetails;
    }

    if (
      questionnarieValues?.belongsToGroup?.toString() !== 'null' &&
      questionnarieValues?.belongsToGroup?.toString() !== 'undefined'
    ) {
      questionnarieBody.belongsToGroup = Boolean(
        questionnarieValues.belongsToGroup === 'yes',
      );
    }

    if (questionnarieValues?.parentCompanyName) {
      questionnarieBody.parentCompanyName =
        questionnarieValues?.parentCompanyName;
    }

    if (questionnarieValues?.parentCompanyCountryId) {
      questionnarieBody.parentCompanyCountryId =
        questionnarieValues?.parentCompanyCountryId;
    }

    if (questionnarieValues?.subsidiariesInfo) {
      questionnarieBody.subsidiariesInfo =
        questionnarieValues?.subsidiariesInfo;
    }

    if (questionnarieValues?.mainActivities) {
      questionnarieBody.mainActivities = questionnarieValues?.mainActivities;
    }

    if (questionnarieValues?.groupWealthSourceIds) {
      questionnarieBody.groupWealthSourceIds =
        questionnarieValues?.groupWealthSourceIds;
    }

    if (questionnarieValues?.groupWealthSourceOther) {
      questionnarieBody.groupWealthSourceOther =
        questionnarieValues?.groupWealthSourceOther;
    }

    if (questionnarieValues?.estimatedTotalWealthEuro) {
      questionnarieBody.estimatedTotalWealthEuro = Number(
        questionnarieValues?.estimatedTotalWealthEuro,
      );
    }

    if (
      questionnarieValues?.customerAppliesKycProcedures?.toString() !==
        'null' &&
      questionnarieValues?.customerAppliesKycProcedures?.toString() !==
        'undefined'
    ) {
      questionnarieBody.customerAppliesKycProcedures = Boolean(
        questionnarieValues.customerAppliesKycProcedures === 'yes',
      );
    }

    if (
      questionnarieValues?.hasBusinessActivity?.toString() !== 'null' &&
      questionnarieValues?.hasBusinessActivity?.toString() !== 'undefined'
    ) {
      questionnarieBody.hasBusinessActivity = Boolean(
        questionnarieValues.hasBusinessActivity === 'yes',
      );
    }

    if (
      questionnarieValues?.businessActivitiesIds &&
      questionnarieValues?.businessActivitiesIds[0] !== 'NONE'
    ) {
      questionnarieBody.businessActivitiesIds =
        questionnarieValues?.businessActivitiesIds;
    }

    if (questionnarieValues?.customersMainClientsIds) {
      questionnarieBody.customersMainClientsIds =
        questionnarieValues?.customersMainClientsIds;
    }

    if (questionnarieValues?.customersMainClientsOther) {
      questionnarieBody.customersMainClientsOther =
        questionnarieValues?.customersMainClientsOther;
    }

    if (questionnarieValues?.salesChannelsIds) {
      questionnarieBody.salesChannelsIds =
        questionnarieValues?.salesChannelsIds;
    }

    if (questionnarieValues?.salesChannelsOther) {
      questionnarieBody.salesChannelsOther =
        questionnarieValues?.salesChannelsOther;
    }

    if (questionnarieValues?.numberOfEmployees) {
      questionnarieBody.numberOfEmployees = Number(
        questionnarieValues?.numberOfEmployees,
      );
    }

    if (
      questionnarieValues?.hasAccountsInOtherFinancialInstitutions?.toString() !==
        'null' &&
      questionnarieValues?.hasAccountsInOtherFinancialInstitutions?.toString() !==
        'undefined'
    ) {
      questionnarieBody.hasAccountsInOtherFinancialInstitutions = Boolean(
        questionnarieValues.hasAccountsInOtherFinancialInstitutions === 'yes',
      );
    }

    if (questionnarieValues?.otherFinancialInstitutions) {
      questionnarieBody.otherFinancialInstitutions =
        questionnarieValues?.otherFinancialInstitutions;
    }

    if (questionnarieValues?.sourcesOfFundsIds) {
      questionnarieBody.sourcesOfFundsIds =
        questionnarieValues?.sourcesOfFundsIds;
    }

    if (questionnarieValues?.sourcesOfFundsLoanBusinessPartner) {
      questionnarieBody.sourcesOfFundsLoanBusinessPartner =
        questionnarieValues?.sourcesOfFundsLoanBusinessPartner;
    }

    if (questionnarieValues?.sourcesOfFundsLoanCreditInstitution) {
      questionnarieBody.sourcesOfFundsLoanCreditInstitution =
        questionnarieValues?.sourcesOfFundsLoanCreditInstitution;
    }

    if (questionnarieValues?.sourcesOfFundsOther) {
      questionnarieBody.sourcesOfFundsOther =
        questionnarieValues?.sourcesOfFundsOther;
    }

    if (questionnarieValues?.sourceOfWealthIds) {
      questionnarieBody.sourceOfWealthIds =
        questionnarieValues?.sourceOfWealthIds;
    }

    if (questionnarieValues?.sourceOfWealthOther) {
      questionnarieBody.sourceOfWealthOther =
        questionnarieValues?.sourceOfWealthOther;
    }

    if (questionnarieValues?.estimatedTotalWealth) {
      questionnarieBody.estimatedTotalWealth = Number(
        questionnarieValues?.estimatedTotalWealth,
      );
    }

    if (questionnarieValues?.annualIncome) {
      questionnarieBody.annualIncome = Number(
        questionnarieValues?.annualIncome,
      );
    }

    if (questionnarieValues?.sourcesOfAnnualIncomes?.length) {
      questionnarieBody.sourcesOfAnnualIncomes =
        questionnarieValues?.sourcesOfAnnualIncomes;
    }

    if (questionnarieValues?.sourcesOfAnnualIncomesOther) {
      questionnarieBody.sourcesOfAnnualIncomesOther =
        questionnarieValues?.sourcesOfAnnualIncomesOther;
    }

    if (questionnarieValues?.accountTypeIds) {
      questionnarieBody.accountTypeIds = questionnarieValues?.accountTypeIds;
    }
  }

  return questionnarieBody;
};

export default getCorporateQuestionnarieBody;
